// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__+6BsO"};